import React, {useEffect, useState} from 'react';
import {SaveOutlined} from "@ant-design/icons";
import {user_data} from "../../../../../../../../components/functions/usr";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import axios from "axios";
import {header} from "../../../../../../../../components/api/Header";
import decade_days, {gmslar} from "../../../../../../../../components/sfr/maydon";
import { getEnv } from "../../../../../../../../lib/env";

function LimitInsert(props) {
    const user = user_data()
    const year = localStorage.getItem('sfr-hm-year')?localStorage.getItem('sfr-hm-year'):new Date().getFullYear()
    const [swed,setSwed] = useState({})
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const [istemolchilar, setIstemolchilar] = useState(ist?JSON.parse(ist):[])
    const ste1 = localStorage.getItem("sfr-hm-ste")
    const [ste,setSte] = useState(ste1?JSON.parse(ste1):{})
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const ekin = localStorage.getItem("sfr-hm-veg-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const [maydonlar, setMaydonlar] = useState({})
    const [sanTex, setSanTex] = useState(1)
    const [reja,setReja] = useState(0)
    const cropid = localStorage.getItem('sfr-hm-veg-ekinids')
    const cropids = cropid?JSON.parse(cropid):[]
    const sfrMaydon = localStorage.getItem("sfr-hm-veg-maydon")
    const sfrMaydonlar = sfrMaydon?JSON.parse(sfrMaydon):{}
    const [limit,setLimit] = useState(localStorage.getItem('sfr-hm-veg-limit')?localStorage.getItem('sfr-hm-veg-limit'):1)
    let gmss = []
    const koifsent1 = localStorage.getItem('sfr-hm-veg-koifsent')
    const [koifsent, setKoifsent] = useState(koifsent1?koifsent1:0)
    useEffect(()=>{
        const fetchSwed = async (gmss, gmss2) => {
            const postData = {
                crops: cropids,
                gmss,
                maydonlar: gmss2,
                tomorqa1: true
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/veg_sugorish_meyyori2",
                postData,
                header()
            )
                .catch(e => {
                    console.log("Xato", e)
                })
            if (res) {
                setSwed(res.data)
            }
        }
        const maydon = () => {
            let gidromodullar = []
            istemolchilar.map(i => {
                if (i.gms) {
                    i.gms.map(g => {
                        if (!gidromodullar.includes(g)) {
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydon()
        const gmss2 = gmslar(sfrMaydonlar,cropids)
        setMaydonlar(gmss2)
        if (gmss2)
            fetchSwed(gmss, gmss2)
    },[])
    useEffect(() => {
        const xisoblash = () => {
            let jami = 0;
            if (istemolchilar.length) {
                istemolchilar.map((istemolchi, i) => {
                    Object.keys(ekinlar).map(e => {
                        for (let deks = 1; deks < 19; deks++) {
                            let eg = 0
                            if (swed[e.slice(1)]) {
                                istemolchi.gms.map(gms2 => {
                                    if (swed[e.slice(1)][gms2]) {
                                        let jm = maydonlar['g' + gms2] ? maydonlar['g' + gms2][e] : 0
                                        let im = sfrMaydonlar['i' + istemolchi.id] ? sfrMaydonlar['i' + istemolchi.id]['g' + gms2] ? sfrMaydonlar['i' + istemolchi.id]['g' + gms2][e] : 0 : 0
                                        let ds = swed[e.slice(1)][gms2][deks]
                                        eg = addFunc(eg, (bolFunc(im, jm) * ds))
                                    }
                                })
                            }
                            jami = addFunc(jami, bolFunc(eg, istemolchi.fik))
                        }

                    })
                })
            }
            let jste = 0
            const dekdays = decade_days('veg', year)
            ste.map(st => {
                let fik = manbalar.filter(m => m.id == st.manba)[0].fik
                let este = 0
                for (var deks = 1; deks < 19; deks++) {
                    let d = st['d' + deks] * (0.0864 * dekdays['d' + deks])
                    este = addFunc(este, d)
                }
                let tste = bolFunc(bolFunc(este, 1000), fik)
                jste = addFunc(jste, tste)
            })
            setSanTex(jste)
            jami = bolFunc(jami,1000)
            jami = addFunc(jste,jami)
            setReja(jami)
        }
        if (Object.keys(swed).length > 0) {
            xisoblash()
        }
    }, [swed]);
    const changeLimitHandler = (type,id,lim,v) => {
        if(type == 'ist'){
            let nist = [...istemolchilar]
            for(var i = 0; i < nist.length; i++){
                if(nist[i].id == id){
                    if(!nist[i].limit){
                        nist[i].limit = {daryo:'',yer:'',zovur:''}
                    }
                    nist[i].limit[lim] = v
                }
            }
            setIstemolchilar(nist)
        }else if(type == 'ste'){
            let nste = [...ste]
            for(var i = 0; i < nste.length; i++){
                if(nste[i].id == id){
                    if(!nste[i].limit){
                        nste[i].limit = {daryo:'',yer:'',zovur:''}
                    }
                    nste[i].limit[lim] = v
                }
            }
            setSte(nste)
        }
    }

    const fetch = () => {
        let res = []
        if(manbalar.length){
            manbalar.map(m=>{
                let nm = {}
                nm.manba = m.name
                nm.ist = []
                if(istemolchilar.length){
                    istemolchilar.map(is=>{
                        if(is.mid == m.id){
                            nm.ist.push({id:is.id,name:is.name,limit:is.limit,type:'ist'})
                        }
                    })
                }
                if(ste.length){
                    ste.map(s=>{
                        if(s.manba == m.id){
                            nm.ist.push({id:s.id,name:s.name,limit:s.limit,type:'ste'})
                        }
                    })
                }
                res.push(nm)
            })
        }
        let co = 0;
        return res.map((r,i)=>{
            return r.ist.length?
                r.ist.map((is,index)=>{
                    co++;
                    return <tbody key={index}>
                    <tr>
                        <td>{co}</td>
                        <td>{is.name}</td>
                        <td className="inptd">
                            <input type="number" className="inputable no-arrow text-center" value={is.limit?is.limit.daryo:''}
                                   onChange={e=>changeLimitHandler(is.type,is.id,'daryo',e.target.value)}
                            />
                        </td>
                        <td>
                            <input type="number" className="inputable no-arrow text-center" value={is.limit?is.limit.yer:''}
                                   onChange={e=>changeLimitHandler(is.type,is.id,'yer',e.target.value)}
                            />
                        </td>
                        <td>
                            <input type="number" className="inputable no-arrow text-center" value={is.limit?is.limit.zovur:''}
                                   onChange={e=>changeLimitHandler(is.type,is.id,'zovur',e.target.value)}
                            />
                        </td>
                    </tr>
                    {
                        r.ist.length == index + 1? <tr><td colSpan={5} className="text-center">{r.manba}</td></tr>:null
                    }
                    </tbody>

                })

                :null
        })
    }
    const setLimitHandler = (l) => {
        setLimit(l)
        const k = bolFunc((l-sanTex),(reja-sanTex))
        setKoifsent(k)
    }
    const setKoifsentHandler = k => {
        setKoifsent(k)
        const l = (k * (reja - sanTex)) + sanTex
        setLimit(l)
    }
    return (
        <div className="row">
            <div className="col-12 my-4">
                <h3 className="text-center">Limit kiritish</h3>
                <div className="row">
                    <div className="col-6">
                        <div className="flextable p-3" style={{height:"70vh"}}>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th colSpan={5}>
                                        {user.district} bo'yicha {year} - yil nosug'orish davrida olinadigan suv limiti
                                    </th>
                                </tr>
                                <tr>
                                    <th>T/r</th>
                                    <th>Hududlar nomi</th>
                                    <th>Ichki daryo va soylar</th>
                                    <th>Yer osti suvlari</th>
                                    <th>Qaytadan ishlatiladigan suvlar (zovur)</th>
                                </tr>
                                </thead>
                                {fetch()}
                            </table>
                        </div>
                    </div>
                    <div className="col-6 flex-column d-flex justify-content-between pb-3 pt-5">
                        <div className="row">
                            <div className="col-12 mt-5 pt-5">
                                <div className="row">
                                    <div className="col text-center">
                                        <h5>Reja</h5>(mln.m<sup>3</sup>)
                                    </div>
                                    <div className="col text-center">
                                        <h5>San-tex </h5>(mln.m<sup>3</sup>)
                                    </div>
                                    <div className="col text-center">
                                        <h5>Ajratilgan limit</h5>mln.m<sup>3</sup>
                                    </div>
                                    <div className="col text-center">
                                        <h5>Sug'orish limit koefsenti</h5>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col text-center">
                                        <h3>{fixIt(reja,5)}</h3>
                                    </div>
                                    <div className="col text-center">
                                        <h3>{fixIt(sanTex,3)}</h3>
                                    </div>
                                    <div className="col text-center">
                                        <input type="number" className="form-control mx-auto" style={{maxWidth:"150px"}} onChange={e=>setLimitHandler(e.target.value)} value={limit}/>
                                    </div>
                                    <div className="col text-center">
                                        <input type="number" className="form-control mx-auto" style={{maxWidth:"100px"}} onChange={e=>setKoifsentHandler(e.target.value)} value={koifsent}/>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div>
                            <button className="btn btn-success d-flex align-items-center btn-lg" onClick={() => {
                                localStorage.setItem('sfr-hm-istemolchilar', JSON.stringify(istemolchilar))
                                localStorage.setItem('sfr-hm-ste', JSON.stringify(ste))
                                localStorage.setItem('sfr-hm-veg-koifsent', JSON.stringify(koifsent))
                                localStorage.setItem('sfr-hm-veg-limit', JSON.stringify(parseFloat(limit)))
                                window.location = "/sfr/gidromodul/new/limits/table1"
                            }}>
                                <SaveOutlined/>&nbsp;&nbsp;Saqlash
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LimitInsert;